import React from 'react';
import PropTypes from 'prop-types';
import { useMassActionState } from 'src/components/massAction/MassActionStateContext';
import EmailContentLabel from 'src/components/common/contentEditor/EmailContentLabel';

EmailContentLabel.propTypes = {
  contentValidity: PropTypes.object.isRequired,
};

const MassActionEmailContentLabel = props => {
  const [{ contentValidity }] = useMassActionState();
  return <EmailContentLabel contentValidity={contentValidity} {...props} />;
};

export default MassActionEmailContentLabel;
